import { Star } from "lucide-react";
import { REVIEWS, PRESS } from "@/data/site";
import SEO from "@/components/SEO";
import { Reveal, MaskedLines } from "@/components/Reveal";
import ReviewsCarousel from "@/components/ReviewsCarousel";
import { CTABanner } from "@/components/sections";

export default function Reviews() {
  return (
    <>
      <SEO
        title="Reviews & Press — Top-Rated Salon in Hell's Kitchen, NYC"
        description="Read what New Yorkers say about Maison Neuf and see our press features. Five-star hair, nails, facials and waxing in Hell's Kitchen, Manhattan."
      />
      <section className="mx-auto max-w-[1400px] px-5 pt-36 pb-16 md:px-10 md:pt-44" data-testid="reviews-hero">
        <p className="label mb-6 text-wine">Reviews / Press</p>
        <h1 className="max-w-4xl font-display text-5xl leading-[1.0] md:text-8xl">
          <MaskedLines lines={["Loved across", "the five boroughs."]} />
        </h1>
      </section>

      <section className="mx-auto max-w-[1400px] px-5 pb-16 md:px-10" data-testid="reviews-featured">
        <div className="border-y border-border py-16">
          <ReviewsCarousel />
        </div>
      </section>

      <section className="mx-auto max-w-[1400px] px-5 pb-24 md:px-10" data-testid="reviews-grid">
        <div className="grid gap-px bg-border sm:grid-cols-2 lg:grid-cols-4">
          {REVIEWS.map((r, i) => (
            <Reveal key={i} delay={(i % 4) * 0.08}>
              <div className="h-full bg-background p-8">
                <div className="mb-5 flex gap-1 text-wine">
                  {Array.from({ length: r.stars }).map((_, k) => <Star key={k} className="h-4 w-4 fill-current" />)}
                </div>
                <p className="text-foreground/90">“{r.text}”</p>
                <p className="mt-5 font-mono text-xs uppercase tracking-[0.16em] text-muted-foreground">{r.name} — {r.area}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="border-t border-border" data-testid="reviews-press">
        <div className="mx-auto max-w-[1400px] px-5 py-20 md:px-10 md:py-24">
          <p className="label mb-10 text-wine">As seen in</p>
          <div className="grid grid-cols-2 gap-y-10 sm:grid-cols-3 lg:grid-cols-6">
            {PRESS.map((p) => (
              <span key={p} className="font-display text-2xl italic text-muted-foreground">{p}</span>
            ))}
          </div>
        </div>
      </section>

      <CTABanner title="Become the next five-star review." />
    </>
  );
}
